import { Component, inject, OnInit } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { NavbarService } from '../../../Services/navbar.service';
import { Router, RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { FirmService } from '../../../Services/firm.service';
import { FirmSelectionService } from '../../../Services/firm-selection.service';
import { NotificationService } from '../../../Services/notification.service';
import { AuthService } from '../../../Services/auth.service';

@Component({
  selector: 'app-sub-header',
  standalone: true,
  imports: [NgClass, NgFor, NgIf, RouterLink, FormsModule],
  templateUrl: './sub-header.component.html',
  styleUrl: './sub-header.component.css',
})
export class SubHeaderComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;
  navbarOptions: any[] = [];
  isFirmLocked: boolean = false;

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) { }

  navService = inject(NavbarService);

  router = inject(Router);

  // menu toggle state
  menuOpen = false;

  // mobile submenu expand/collapse state
  mobileExpanded: string | null = null;

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSubmenu(path: string) {
    this.mobileExpanded = this.mobileExpanded === path ? null : path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;       // close mobile menu
    this.mobileExpanded = null;  // collapse submenu
  }
  // get navbarOptions()
  // {
  ngOnInit(): void {
    const userRole = sessionStorage.getItem('role');
    this.isFirmLocked = (sessionStorage.getItem('is_firm_restricted') === 'true') || (userRole === 'Staff');

    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      // Reflect current selection
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          this.selectedFirm = firm.name;
        }
      });
    });

    this.loadFirms();  // initial load

    // 👇 NEW: Listen for updates from FirmService
    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms(); // reload whenever a firm is added/edited/deleted
    });

    this.navService.navbarOptions$.subscribe(options => {
      this.navbarOptions = options;
    });
  }

  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.firmSelectionService.setselectedFirmName({ id: firm.id, name: firm.name, status: firm.gst_status });
      }
    });
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      console.log("check firm data ", firms)
      this.firmnames = firms.map((firm: any) => firm.name);

      // Reflect current selection
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        if (firm) {
          this.selectedFirm = firm.name;
        }
      });
    });
  }

  isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    // ✅ Close only if focus moved outside the wrapper
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}
